const InvestmentChallenge1HintsText =
    ["Stocks are the only investment type that gives you a stake in the company. ",
     "Investing in an index fund is an effective way to diversify your portfolio. " , 
     "One of the items describes a low-risk savings option.  This investment type " +
        "is ideal for short-term savings that extend beyond one year.  ",  
     "The investment that offers steady, fixed interest is one where you are " +
        "actually becoming a lender."
    ]
   
export default InvestmentChallenge1HintsText;